import { Map } from 'immutable';
export default class ServiceBase {
    constructor(store, config) {
        var me = this;
        me.clearCache();
        
        me.setStore(store);
    }
    getStore() {
        return this._store;
    }
    setStore(store) {
        var me = this;
        if (!store) {
            return;
        }

        if (me._store) {
            return;
        }

        me.clearCache();
        me._store = store;
        me._unsubscribe = me._store.subscribe(me.onChange.bind(me));
    }
    clearCache() {
        var me = this;
        if (me._unsubscribe) {
            me._unsubscribe();
            me._unsubscribe = null;
        }
        me.listeners = [];
        me._store = null;
        me._oldState = {};
    }
    onChange() {
        var me = this;
        var key = me.config.key;
        var state = me._store.getState()[key];
        var oldState = me._oldState;
        if (Map.isMap(oldState) && Map.isMap(state) && state.equals(oldState)) {
            return;
        }
        me._oldState = state;
        me.listeners.forEach(function (func) {
            func && func(state);
        })
    }
    dispatch(action) {
        this._store.dispatch(action);
    }
    getState() {
        return this._store.getState()[this.config.key];
    }
    //返回unsubscribe函数
    subscribe(func) {
        var me = this;
        if (typeof func !== 'function') return;
        me.listeners.push(func);
        return function () {
            var n = -1

            for (var i = 0; i < me.listeners.length; i++) {
                if (func === me.listeners[i]) {
                    n = i;
                }
            }

            if (n > -1)
                me.listeners.splice(n, 1);
        }
    }
    getConfig() { }
    init() { }
    query() { }
    add() { }
    remove() { }
    update() { }
}


// WEBPACK FOOTER //
// ./_source/cqsx/services/service-base.js